<!-- ? V2 1XP -->

<script lang="ts">
import type { ValueOf } from '../../types/helper';
import Icon from '../Icon/Icon.vue';

const colors = {
  blue: 'blue',
  white: 'white',
  grey: 'grey',
} as const;

const sizes = {
  s: 's',
  lg: 'lg',
} as const;

type Props = {
  color: ValueOf<typeof colors>;
  endIcon?: string;
  size: ValueOf<typeof sizes>;
  startIcon?: string;
  text?: string;
};
</script>

<script setup lang="ts">
withDefaults(defineProps<Props>(), {
  color: 'white',
  size: 's',
});
</script>

<template>
  <div :class="[$style.container, $style[`color-${colors[color]}`], $style[`size-${sizes[size]}`]]">
    <Icon v-if="startIcon" :name="startIcon" size="small" />
    <span :class="$style.text"> {{ text }} </span>
    <Icon v-if="endIcon" :name="endIcon" size="small" />
  </div>
</template>

<style module lang="scss" src="./Badge.scss" />
